import React from "react";

export const VIEWSPARK_HELP_EMAIL = "help@viewspark.com";

type ContactsProcessingBannerNoticeProps = {
  linkClassName?: string;
};

export function ContactsProcessingBannerNotice({
  linkClassName,
}: ContactsProcessingBannerNoticeProps) {
  return (
    <>
      We&apos;re processing your contacts. This may take a while. Posts
      delivering will stay paused until your contacts are fully processed.
      Questions? Email{" "}
      <a className={linkClassName} href={`mailto:${VIEWSPARK_HELP_EMAIL}`}>
        {VIEWSPARK_HELP_EMAIL}
      </a>
    </>
  );
}
